import { EscalationContactCard } from "./components/EscalationContactCard";
import ChevronLeftIcon from "../../../../assets/svg/chevron-left-icon";
import ChevronRightIcon from "../../../../assets/svg/chevron-right-icon";
import { useScrollNavigation } from "../../../../hooks/use-scroll-navigation";
import { EscalationContactSectionDataResponse } from "../../../../redux/services/kamApi";

export const EscalationContactSection = ({
  escalationContactSectionData,
}: {
  escalationContactSectionData?: EscalationContactSectionDataResponse;
}) => {
  const {
    containerRef,
    isScrollable,
    canScrollLeft,
    canScrollRight,
    scrollTo,
    checkScrollState,
  } = useScrollNavigation(800);

  const { escalation_matrix } = escalationContactSectionData || {};
  const hasEscalationContacts = Boolean(escalation_matrix?.length);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between gap-4 pr-4">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-1">
            <span className="text-base font-medium text-heading-text dark:text-heading-text-dk">
              Need Assistance? We're Here to Help
            </span>
            <span className="py-0.5 px-1.5 rounded text-xxs font-semibold text-verba-indigo dark:text-verba-indigo-dk border border-gray-100 dark:border-gray-100-dk">
              1 / 3
            </span>
          </div>
          <span className="text-xs text-data dark:text-data-dk">
            If you're facing any issues, please contact your Account Manager or
            you can also follow the Escalation Matrix for support.
          </span>
        </div>

        {isScrollable && hasEscalationContacts && (
          <div className="flex gap-1">
            <button
              onClick={() => scrollTo("left")}
              disabled={!canScrollLeft}
              className="w-5 h-5 flex items-center justify-center rounded-[3px] text-verba-indigo dark:text-verba-indigo-dk bg-hover-effect dark:bg-hover-effect-dk disabled:bg-pure-white dark:disabled:bg-pure-white-dk hover:bg-verba-blue dark:hover:bg-verba-blue-dk hover:text-fixed-white dark:hover:text-fixed-white-dk disabled:hover:text-verba-indigo dark:disabled:hover:text-verba-indigo-dk disabled:opacity-40 disabled:cursor-not-allowed transition-all"
            >
              <ChevronLeftIcon className="w-4 h-4 text-heading dark:text-heading-dk" />
            </button>
            <button
              onClick={() => scrollTo("right")}
              disabled={!canScrollRight}
              className="w-5 h-5 flex items-center justify-center rounded-[3px] text-verba-indigo dark:text-verba-indigo-dk bg-hover-effect dark:bg-hover-effect-dk disabled:bg-pure-white dark:disabled:bg-pure-white-dk hover:bg-verba-blue dark:hover:bg-verba-blue-dk hover:text-fixed-white dark:hover:text-fixed-white-dk disabled:hover:text-verba-indigo dark:disabled:hover:text-verba-indigo-dk disabled:opacity-40 disabled:cursor-not-allowed transition-all"
            >
              <ChevronRightIcon className="w-4 h-4 text-heading dark:text-heading-dk" />
            </button>
          </div>
        )}
      </div>
      <div
        ref={containerRef}
        onScroll={checkScrollState}
        className="overflow-x-auto no-scrollbar pr-4"
      >
        {hasEscalationContacts ? (
          <div className="flex gap-3 w-max">
            {escalation_matrix?.map((level, index) => (
              <EscalationContactCard key={index} data={level} level={index + 1} />
            ))}
          </div>
        ) : (
          <div className="w-full h-[128px] rounded-lg border border-border-gray dark:border-border-gray-dk flex items-center justify-center text-sm text-data dark:text-data-dk">
            -
          </div>
        )}
      </div>
    </div>
  );
};
